import React, { useMemo } from 'react';
import { Bubble, BubbleProps } from 'tea-component';
import './index.scss';
import { uniqueArray } from '@/pages/opinion/utils';
import { useIntl } from 'umi';
import { reviewsFormat } from '@op/utils/value';

export interface IMultiRingRatioDataItem {
  oldTime: Array<string>;
  newTime: Array<string>;
  oldValue: number | string;
  newValue: number | string;
  title?: string;
  otherInfo?: any;
  formatDate?: (date: string) => string;
  formatValue?: (value: number | string) => string | number;
};

interface IMultiRingRatioBubbleProps {
  showContent?: boolean;
  data: IMultiRingRatioDataItem[];
  children: React.ReactNode;
  bubbleProps?: React.ForwardRefExoticComponent<
    BubbleProps & React.RefAttributes<HTMLDivElement>
  >;
  placement?: string;
};
export default function MultiRingRatioBubble({
  data,
  showContent = true,
  children,
  placement = 'top',
  ...bubbleProps
}: IMultiRingRatioBubbleProps) {

  const content = useMemo(() => {
    if (!data?.length || !showContent) return null;

    return data
      .map((each) => {
        const {
          title,
          otherInfo = null,
          oldTime,
          newTime,
          oldValue,
          newValue,
          formatDate = (date: string) => date,
          formatValue = reviewsFormat,
        } = each;

        const noShow = !oldTime?.every(Boolean) && !newTime?.every(Boolean);
        if (noShow) return null;

        const oldTimeText = uniqueArray(oldTime?.map(formatDate)).join(' - ');
        const newTimeText = uniqueArray(newTime?.map(formatDate)).join(' - ');
        const oldValueText = formatValue(oldValue);
        const newValueText = formatValue(newValue);

        if (oldTimeText.length === 0 || (!oldValueText && !newValueText)) {
          return null;
        }

        return (
          <div className="bubble-box" key={title || oldTimeText + newTimeText}>
            {title && <div className="item-title">{title}</div>}
            {otherInfo}
            <div className="item-content">
              <div className="item-date-box">
                <div className="item-date">{newTimeText}</div>
                <div className="item-date">{oldTimeText}</div>
              </div>
              <div className="item-vs">VS</div>
              <div className="item-num-box">
                <div className="item-num">{newValueText}</div>
                <div className="item-num">{oldValueText}</div>
              </div>
            </div>
          </div>
        );
      })
      .filter(Boolean); // filter out nulls
  }, [data, showContent]);

  return (
    <>
      {
        content ?
          <Bubble
            dark
            className="multi-ring-ratio-bubble-wrapper"
            overlayClassName={'multi-ring-ration-bubble-box'}
            placement={placement as any}
            content={content}
            closeOnScroll
            {...bubbleProps}
          >
            <span className="child-item">{children}</span>
          </Bubble> : children
      }
    </>
  );
}
